import "./styles.scss";

interface GlassSceneProps {
  variant?: "isp" | "mvno";
}

/**
 * Fixed, non-interactive atmospheric background. A single element painting
 * layered radial gradients — no blurred child nodes, no animation — so it is
 * essentially free to composite. Sits behind everything (z-index: -1).
 */
export const GlassScene = ({ variant = "isp" }: GlassSceneProps) => {
  return <div className={`glass-scene glass-scene--${variant}`} aria-hidden="true" />;
};
